import React, { useState, useMemo, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../Navigation bar/Navbar";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  useAsyncDebounce,
} from "react-table";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { service_url } from "../../../Configs/mysqlconfig";

function TransporterSummaryT1({TableData,vehicle_order_data, amount_per_service ,additional_amount,max_km_for_fixed_amt  } ) {

  const [show1, setShow1] = useState(false);
  const [invoiceData,setInvoiceData] = useState([]);
  const history = useHistory();
  const InvoiceCreatekeyMap = {
    Short_Cash_Amt: "short_cash_amt",
    additional_kms: "additional_km", 
  };
  const[data,setData] = useState([]);  
  const[error,setError] = useState([]);  
  const[isLoading,setIsLoading] = useState([]);  
  let csv_data = useRef("");


  function createCsv(data, columns) {
    let final_csv = [];
    for (let row of data) {
      let one_row = [];
      for (let col of columns) {
        one_row.push(row[col.accessor]);
      }
      final_csv.push(one_row);
    }

    let one_row = [];
    for (let col of columns) {
      one_row.push(col.accessor);
    }
    final_csv.unshift(one_row);

    csv_data.current = final_csv;
  }

  function aggregateData(data) {
    let aggregatedData = {};
  
    
    for (let dt of data) {
      let companyType = dt.company_type;
      
      //  if the transporter (company_type) already exists in aggregatedData. else init an entry for that transporter.
      if (!aggregatedData[companyType]) {
        aggregatedData[companyType] = { company_type: companyType };
      }
  
      let currObj = aggregatedData[companyType];
  
      // Update fields only if they exist in the current object
      // for invoice related fields we needed this
      ['transporter_id','transporter_name', 'transporter_mobile_number', 'pan', 'transporter_address', 'transporter_status', 'contact_person', 'warehouse']
        .forEach(field => {
          if (dt[field]) currObj[field] = dt[field];
        });
    }
    // [] of values returned
    return Object.values(aggregatedData);
  }

  
// Dah - driver allocation , vo - vehicle order
function addDailyDistance(DaHdata, VoHdata) {
  
  return DaHdata.map(DaHitem => {
      const matches = VoHdata.filter(
          VoHitem => 
            VoHitem.delivery_date == DaHitem.date && 
          VoHitem.vehicle_no == DaHitem.current_Route_Id
      );
      
      // If matches are found, add the daily_distance value
      if (matches.length > 0) {
        const rawDistance = Number(matches[0].daily_distance);
        const kmDistance = !isNaN(rawDistance) ? (rawDistance === 0 ? 0 : rawDistance / 1000) : undefined;

          return {
              ...DaHitem,
              daily_distance: kmDistance 
          };
      }
      
      // If no matches, return the original item
      return DaHitem;
  });
}
// for updating dah data to leading zeroes of date values
function updateDateFields(array) {
  return array.map(item => ({
      ...item, 
      date: standardizeDate(item.date) 
  }));
}
// for adding leading zeroes
function standardizeDate(dateStr) {
  const parts = dateStr.split('-');
  return `${String(parts[0]).padStart(2, '0')}-${String(parts[1]).padStart(2, '0')}-${parts[2]}`;
}

  
    function filterData(Dahdata) {
    
    const updatedDataArray = updateDateFields(Dahdata);
    let data = addDailyDistance(updatedDataArray,vehicle_order_data)

      let obj = {};           // for each transporter aggregate
      let data2 = [];           // final data to be sent 
      let driver_obj = {}    //aggregated data for each driver

      //  driver level calculation for km kms_travelled 
      for (let dt of data) {

        // entry skip if conditin matches
        if(dt.vehicle_status == "absent" || dt.vehicle_status == "vehicle_breakdown" ){
          continue
        }

        // driver ph no. already present, in driver_obj, else init driver obj
        if (driver_obj[dt?.driver_Phone_Number] == undefined) {
          driver_obj[dt?.driver_Phone_Number] = {
            driver_sum_kms: 0,
          };
        }
        // aggregate total kms for each driver

        let curr_obj = driver_obj[dt?.driver_Phone_Number];
        let driver_sum_kms = curr_obj?.driver_sum_kms + Number(dt?.kms_travelled || 0);

        let new_obj = {
          driver_sum_kms: driver_sum_kms,
        }

        driver_obj[dt.driver_Phone_Number] = new_obj;

      }
      // console.log(driver_obj);
      // console.log('----------- driver_obj -------------');
      // main calculation
      for (let dt of data) {

        if(dt.vehicle_status == "absent" || dt.vehicle_status == "vehicle_breakdown" ){
            continue
        }
        
        if (obj[dt.company_type] == undefined) { // for a Transporter, if undefined then init transporter data
          obj[dt.company_type] = {
            driver_Phone_Numbers_str : "",
            transporter: dt.company_type,
            transporter_id: dt.transporter_id,
            pan: dt.pan,
            address: dt.transporter_address,
            mobile:dt.transporter_mobile_number,
            routes_serviced: 0,
            sum_kms: 0,
            additional_kms: 0,
            fixed_amt: 0,
            additional_amt: 0,
            Short_Cash_Amt: 0,
            stock_short_amt: 0,
            penalty_amt: 0,
            payable_amt: 0,
            // route_ids: []
            daily_distance_sum: 0,
            route_ids: new Set() 
          };
        }

        let curr_obj = obj[dt.company_type];
        let sum_kms = curr_obj.sum_kms + Number(dt?.kms_travelled || 0);  //totl kms travels by all vehicles for each transported summed.
        let Short_Cash_Amt =  Number(curr_obj?.Short_Cash_Amt) + Number(dt?.adjustments || 0);
        let stock_short_amt = Number(curr_obj?.stock_short_amt) + Number(dt?.short_items || 0);
        let penalty_amt = Number(curr_obj?.penalty_amt) + Number(dt?.penalty_amt || 0);
        let driver_Phone_Numbers_str = curr_obj.driver_Phone_Numbers_str  + dt.driver_Phone_Number + ","
        // let route_ids = [...curr_obj.route_ids, dt.current_Route_Id];
        curr_obj.route_ids.add(dt.current_Route_Id);
        // update data with agrregated above values.

         // Update daily_distance if it exists
         if (dt.daily_distance) {
          curr_obj.daily_distance_sum += Number(dt.daily_distance); // Aggregate daily_distance
      }

        let new_obj = {
          sum_kms: sum_kms,
          transporter: curr_obj.transporter,
          routes_serviced: Number(curr_obj?.routes_serviced || 0) + 1,
          Short_Cash_Amt: Short_Cash_Amt?.toFixed(2),
          stock_short_amt: stock_short_amt?.toFixed(2),
          penalty_amt: penalty_amt?.toFixed(2),
          driver_Phone_Numbers_str : driver_Phone_Numbers_str,
          route_ids: curr_obj.route_ids,
          daily_distance_sum: curr_obj.daily_distance_sum,
        };

        obj[dt.company_type] = new_obj;
      }

      for (let ob in obj) {
        let current = obj[ob];
        let dpns = new Set(current.driver_Phone_Numbers_str.split(',')) 

        let  total_km_for_driver  =  0
        for ( let  k of dpns ){
        
          total_km_for_driver += ((driver_obj[k]?.driver_sum_kms  - max_km_for_fixed_amt ) > 0) ? (driver_obj[k]?.driver_sum_kms  - max_km_for_fixed_amt ) : 0;
        }
        let fixed_amt = Number(current?.routes_serviced) * amount_per_service;
        // let additional_kms = ((current.sum_kms - max_km_for_fixed_amt) > 0 ) ? current.sum_kms - max_km_for_fixed_amt : 0;
        // let additional_kms = total_km_for_driver -- commented as daily distance sum willbe used
        // Replace additional_kms with daily_distance_sum
        
        // daily distanc esum - max km for fixed amt, total distnace sum -- var name
        
        let additional_kms = ((current.daily_distance_sum - max_km_for_fixed_amt) > 0 ) ? current.daily_distance_sum - max_km_for_fixed_amt : 0;
        let additional_amt = additional_kms > 0 ? Number(additional_kms) * additional_amount : 0;
        let payable_amt = fixed_amt + additional_amt - current.Short_Cash_Amt - current.stock_short_amt -  current.penalty_amt;

        current["fixed_amt"] = fixed_amt;
        current["additional_kms"] = additional_kms.toFixed(2);
        current["additional_amt"] = additional_amt;
        current["payable_amt"] = Number(payable_amt)?.toFixed(2);
         // Convert the Set to an array before pushing to data2
        current["route_ids"] = Array.from(current.route_ids);

        data2.push(current);
      }

      let transporterData = aggregateData(data)
      let mergedData = mergeData(data2,transporterData)
    
      return mergedData;
    }


  function mergeData(finalArray, aggregatedData) {
    // keys company type, values transported details
    const aggregatedDataDict = aggregatedData.reduce((acc, obj) => {
      acc[obj.company_type] = obj;
      return acc;
    }, {});
  
    // Iterate through the finalArray and merge fields from aggregatedData
    return finalArray.map(item => {
      let companyType = item.transporter;
      let aggObj = aggregatedDataDict[companyType];
      
      if (aggObj) {
        // Merge fields from aggObj into item
        return { ...item, ...aggObj };
      }
      return item;
    });
  }


  function changeKeyNames(data, keyMap) {
    return data.map(obj => {
      const newObj = {};
      for (const key in obj) {
        const newKey = keyMap[key] || key;
        if (newKey !== key || obj.hasOwnProperty(key)) {
          newObj[newKey] = obj[key];
        }
      }
      return newObj;
    });
  }

  async function CreateInvoices() {
    const url = `${service_url}/api/superzop/invoice/transporter-invoice-details`;
      let tableData = filterData(TableData);
      let invoicesData = changeKeyNames(tableData,InvoiceCreatekeyMap)
    try {
      let result = await axios.post(url,  invoicesData );
      toast.success("Invoices created for all the transporters");
    } catch (error) {
      console.log(error);
      toast.error("Invoice creation failed");
    }
  }

  async function UpdateInvoices() {
    const url = `${service_url}/api/superzop/invoice/transporter-invoice-details`;
    
      let tableData = filterData(TableData);
      let transporterTableData = tableData;
      
      let updatesData = changeKeyNames(transporterTableData,InvoiceCreatekeyMap)
    try {
      let result = await axios.post(url,  updatesData );
      toast.success("Invoices updated");
    } catch (error) {
      console.log(error);
      toast.error("Invoice creation failed");
    }
  }


  const handleInvoiceClick =  async (row) => {
    let transporterID = row.transporter_id;
    const apiUrl = `${service_url}/api/superzop/invoice/transporter-invoice-details?transporter_id=${transporterID}`;
    try {
      setIsLoading(true);
      const response = await axios.get(apiUrl);
      if (response.data.data.length > 0) {
        setError(null);
        history.push({
          pathname:"/invoice",
          state:{invoiceData : response.data.data,rowData:row}
        })
      } else {
        setData([]);
        toast.error('No data available for the row');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setData([]);
      toast.error('Failed to fetch data');
    } finally {
      setIsLoading(false);
    }
  };


  function Table() {

    let data2 = filterData(TableData);
    let transporterTableData = data2;

    const data = useMemo(() => transporterTableData, [TableData]);
    const columns = useMemo(
      () => [
        {
          Header: "Transporter",
          accessor: "transporter",
          Filter: SelectColumnFilter,
        },
        {
          Header: "Routes serviced",
          accessor: "routes_serviced",
        },
        {
          Header: "Additional kms",
          accessor: "additional_kms",
        },
        {
          Header: "Fixed amt",
          accessor: "fixed_amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.fixed_amt)).toLocaleString('en-IN')  } 
        },
        {
          Header: "Additional amt",
          accessor: "additional_amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.additional_amt)).toLocaleString('en-IN')  } 
        },
        {
          Header: "Short Cash Amt",
          accessor: "Short_Cash_Amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.Short_Cash_Amt)).toLocaleString('en-IN')  } 
        },
        {
          Header: "Stock short amt",
          accessor: "stock_short_amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.stock_short_amt)).toLocaleString('en-IN')  } 
        },
        {
          Header: "Penalty amt",
          accessor: "penalty_amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.penalty_amt)).toLocaleString('en-IN')  } 
        },
        {
          Header: "Payable amt",
          accessor: "payable_amt",
          Cell: ({ row }) => { return Math.round(Number(row.original.payable_amt)).toLocaleString('en-IN')  } 
        }
        // {
        //   Header: "Invoice",
        //   accessor: "invoice",
        //   Cell: ({ row }) => {
        //     return <Button onClick={() => handleInvoiceClick(row.original)}>Print Invoice</Button>;
        //   }
        // }
      ],
      []
    );

    createCsv(data, columns);

    function SelectColumnFilter({
      column: { filterValue, setFilter, preFilteredRows, id },
    }) {
      const options = useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => {
          options.add(row.values[id]);
        });
        return [...options.values()];
      }, [id, preFilteredRows]);

      options.sort()
      
      return (
        <select
          value={filterValue}
          onChange={(e) => {
            setFilter(e.target.value || undefined);
          }}
        >
          <option value="">All</option>
          {options.map((option, i) => (
            <option key={i} value={option}>
              {option}
            </option>
          ))}
        </select>
      );
    }

    const defaultColumn = useMemo(
      () => ({
        Filter: () => null,
      }),
      []
    );

    const GlobalFilter = ({ filter, setFilter }) => {
      const [value, setValue] = useState(filter);
      const onChange = useAsyncDebounce((value) => {
        setFilter(value || undefined);
      }, 1000);
      return (
        <span>
          <input
            placeholder="search..."
            value={value || ""}
            onChange={(e) => {
              setValue(e.target.value);
              onChange(e.target.value);
            }}
          />
        </span>
      );
    };

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state,
      setGlobalFilter,
      preGlobalFilteredRows,
    } = useTable({ columns, data, defaultColumn }, useFilters, useGlobalFilter);

    const { globalFilter } = state;

    return (
      <div>
        <Row>
          <Col>
            <GlobalFilter
              filter={globalFilter}
              setFilter={setGlobalFilter}
            ></GlobalFilter>
          </Col>
          <Col>
            {/* <Button onClick={CreateInvoices}>Create Invoice</Button> */}
          </Col>
          <Col>
            {/* <Button onClick={UpdateInvoices}>Update Invoice</Button> */}
          </Col>
          <Col>
            <CSVLink
              className="btn btn-warning export_btn"
              filename={"Detailed_Report.csv"}
              data={csv_data.current}
            >
              Export Data
            </CSVLink>{" "}
          </Col>
          <Col></Col>
        </Row>
        <br />

        <table
          {...getTableProps()}
          style={{ border: "solid 1px blue", width: "100%" }}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps()}
                    style={{
                      borderBottom: "solid 3px red",
                      background: "aliceblue",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {column.render("Header")}
                    <div>
                      {column.canFilter ? column.render("Filter") : null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "10px",
                          border: "solid 1px gray",
                          background: "papayawhip",
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }


  return (
    <>
      <Table />
    </>
  );
}

export default TransporterSummaryT1;
